/**
 * Formats a timestamp as a French relative time string.
 * Accepts ISO-8601 strings or Unix epoch numbers (seconds or milliseconds).
 */
export function formatRelativeTime(timestamp: string | number): string {
  const now = Date.now()
  let then: number

  if (typeof timestamp === 'number') {
    // Unix epoch — detect seconds vs milliseconds
    // If the value is less than ~1e12, it's in seconds (year ~2001 in ms vs ~33658 in s)
    then = timestamp < 1e12 ? timestamp * 1000 : timestamp
  } else {
    then = new Date(timestamp).getTime()
  }

  if (isNaN(then)) {
    return '—'
  }

  const diffMs = now - then

  if (diffMs < 0) {
    return "à l'instant"
  }

  const diffSeconds = Math.floor(diffMs / 1000)
  const diffMinutes = Math.floor(diffSeconds / 60)
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffMinutes < 1) {
    return "à l'instant"
  }

  if (diffMinutes < 60) {
    return `il y a ${diffMinutes} min`
  }

  if (diffHours < 24) {
    return `il y a ${diffHours}h`
  }

  if (diffDays < 7) {
    return `il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`
  }

  const date = new Date(then)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}`
}
